import React from 'react';
import { useJobsiteCreateInvitationMutation } from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { AlertService } from 'components/alertService';
import { generateSelfOnboardingInvitationLink } from 'containers/selfOnboarding/utils';

export type UseWorkerOnboardingLinkArgs = {
  jobsiteInvitationId: string;
  jobsiteContractorId: string;
  onJobsiteInvitationCreated: (jobsiteInvitationId: string) => void;
};

type UseWorkerOnboardingLinkResult = {
  jobsiteInvitationId: string;
  onboardingLink: string;
  canGenerateOnboardingLink: boolean;
  generateOnboardingLink: () => void;
  isGeneratingOnboardingLink: boolean;
};

export function useWorkerOnboardingLink(
  props: UseWorkerOnboardingLinkArgs,
): UseWorkerOnboardingLinkResult {
  const {
    jobsiteInvitationId,
    jobsiteContractorId,
    onJobsiteInvitationCreated,
  } = props;

  const onboardingLink = React.useMemo(
    () => generateSelfOnboardingInvitationLink(jobsiteInvitationId),
    [jobsiteInvitationId],
  );

  const [jobsiteCreateInvitation, { loading: isCreatingOnboardingLink }] =
    useJobsiteCreateInvitationMutation({
      variables: { input: { jobsiteContractorId } },
      onCompleted: (result): void => {
        onJobsiteInvitationCreated(
          result.jobsiteCreateInvitation.jobsiteInvitation.jobsiteInvitationId,
        );
        AlertService.alert(
          'success',
          'Success',
          'Worker onboarding link generated',
        );
      },
      onError: (error): void => {
        AlertService.alert(
          'danger',
          'Something went wrong!',
          getGraphQLError(error),
        );
      },
    });

  return {
    jobsiteInvitationId,
    onboardingLink,
    canGenerateOnboardingLink: !!jobsiteContractorId,
    generateOnboardingLink: jobsiteCreateInvitation,
    isGeneratingOnboardingLink: isCreatingOnboardingLink,
  };
}
